export enum CriterionValues {
    BID_LANGUAGE = "CRITERION.OTHER.BID.LANGUAGE",
    BID_GUARANTEE = "CRITERION.OTHER.BID.GUARANTEE",
    CONTRACT_GUARANTEE = "CRITERION.OTHER.CONTRACT.GUARANTEE"
}
